<template>
  <div class="main-content columns is-centered">
    <div class="column is-11">
      <div class="columns">
        <div class="column has-text-centered">
          <validation-observer
            ref="profile-fields"
            tag="form"
            class="has-text-left"
          >
            <profile
              v-bind="{ type: 'new-user', formTitle: 'New Filers Information', formDesc: 'Build your Financial Disclosure profile' }"
              @profile="userProfile = $event"
            />
          </validation-observer>
          <validation-observer
            ref="login-info-fields"
            tag="form"
            class="has-text-left"
          >
            <login-info
              @loginInfo="loginInfo = $event"
            />
          </validation-observer>
          <div class="has-text-left">
            <positions
              v-bind="{ type: 'new-user' }"
              @positions="positions = $event"
              @hasPositions="hasPositions = $event"
              @hasPrimaryPosition="hasPrimaryPosition = $event"
              @hasPositionsReady="hasPositionsReady = $event"
            />
          </div>
          <validation-observer
            ref="selected-statements-fields"
            tag="form"
            class="has-text-left"
          >
            <statement-requirements
              v-bind="{ type: 'new-user', forceState: true }"
              @requiredStatements="requiredStatements = $event"
            />
          </validation-observer>
        </div>
      </div>
      <div class="columns">
        <div class="column has-text-centered">
          <button
            id="register-btn"
            type="button"
            class="button is-primary"
            :class="isSaving ? 'is-loading' : ''"
            :disabled="isSaving"
            @click.prevent="registerUser"
          >
            Register New User
          </button>
        </div>
      </div>
      <br>
    </div>
  </div>
</template>
<script>
import Profile from '@/components/Profile';
import Positions from '@/components/Positions';
import LoginInfo from '@/components/LoginInfo';
import StatementRequirements from '@/components/StatementRequirements';
import { controlValueHelpers } from '@/mixins/controlValue';

export default {
  name: 'UserRegistration',
  components: {
    Profile,
    Positions,
    LoginInfo,
    StatementRequirements,
  },
  mixins: [
    controlValueHelpers,
  ],
  data() {
    return {
      userProfile: {},
      loginInfo: {},
      isSaving: false,
      positions: [],
      hasPositions: false,
      hasPrimaryPosition: true,
      requiredStatements: {},
    };
  },
  computed: {},
  async created () {
    this.ready = true;
  },
  methods: {
    async registerUser () {

      let isValidProfile = await this.$refs['profile-fields'].validate();
      let isValidLoginInfo = await this.$refs['login-info-fields'].validate();
      let isValidStatements = await this.$refs['selected-statements-fields'].validate();

      this.isSaving = true;

      if (
        !isValidProfile ||
        !isValidLoginInfo ||
        !isValidStatements ||
        !this.hasPositions ||
        !this.hasPrimaryPosition
      ) {
        let warnings = [];
        warnings.push("There are some validation issues.");
        if (!this.hasPrimaryPosition) {
          warnings.push("You must have 1 primary position. Edit the primary position (which you currently hold) and check the \"Primary Position\" box.");
        }
        warnings.push("Please review your information and try again.");
        this.$warning(warnings.join(' '));
        this.isSaving = false;
        return false;
      }

      let newProfile = { ...this.userProfile, ...this.loginInfo, ...this.requiredStatements };
      newProfile.username = newProfile.emailAddress;
      newProfile.filer = 'Y';
      newProfile.selfRegister = 'Y';
      newProfile.active = null;
      newProfile.approved = null;

      let positions = this.positions.slice(0);
      positions.map(position => {
        delete position.id;
      });

      newProfile.positions = positions;

      let save = await this.$store.dispatch('user/registerNewUser', { fields: newProfile });
      if (save) {
        this.$router.push({ name: 'user-registered', params: { profile: save.data }});
      } else {
        this.isSaving = false;
      }

    },
  },
};
</script>
